import { render, staticRenderFns } from "./anamneseDashboardSettings.vue?vue&type=template&id=26b418b6&scoped=true"
import script from "./anamneseDashboardSettings.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSettings.vue?vue&type=script&lang=js"
import style0 from "./anamneseDashboardSettings.vue?vue&type=style&index=0&id=26b418b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b418b6",
  null
  
)

export default component.exports